import { deepFreeze } from '@repo/utils'

import type { ActionFlow } from '../types.action-flow'

import { assertNoDoubleWait } from './stepCallbacks'

// Creates an immutable action flow with compile time and runtime immutability
export function createImmutableActionFlow({
  chainId,
  label,
  tag,
  signatureRequests,
  callRequests,
  expectedAccountAddress,
  reset,
  onSuccess,
  attribution
}: ActionFlow): ActionFlow {
  // `after` on call N together with `before` on call N+1 pays the same wait
  // twice — pick one side. See ADR-2026-05-07 §Authoring rules.
  assertNoDoubleWait(callRequests)

  const actionFlow = {
    chainId,
    label,
    tag,
    signatureRequests: signatureRequests.map(req => ({ ...req })), // deep clone items to not freeze originals
    callRequests: callRequests.map(req => ({ ...req })), // deep clone items to not freeze originals
    expectedAccountAddress,
    reset,
    onSuccess,
    // Shallow-clone so the subsequent deepFreeze doesn't freeze the caller's
    // original object (matches the clone-before-freeze pattern above). Ternary
    // preserves `undefined` — `{ ...undefined }` would yield a truthy `{}` and
    // make resolveAttributionOriginTag falsely treat the flow as opted-in.
    attribution: attribution ? { ...attribution } : undefined
  }

  // Deep freeze for runtime immutability
  return deepFreeze(actionFlow)
}
